import { render, staticRenderFns } from "./config.vue?vue&type=template&id=065612ef"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065612ef')) {
      api.createRecord('065612ef', component.options)
    } else {
      api.reload('065612ef', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=065612ef", function () {
      api.rerender('065612ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/8-2-guide-add-wechat/config.vue"
export default component.exports